<div class="button-toolbar">

  <div style="display: flex; justify-content: space-between; align-items:flex-start;">
    <div style="align-items:flex-start">

      <div class="btn-group" role="group">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Reset
          </button>

          <ul class="dropdown-menu">
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reload the application from the server">
                <a class="dropdown-item" (click)="onButtonAction('resetApplication','')">Application</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reset the section currently selected">
                <a class="dropdown-item" (click)="onButtonAction('resetSection','')">Section</a>
              </span>
            </li>

          </ul>
        </span>
      </div>

      <button type="button" class="btn btn-light" *ngIf="showRemoveButton();"
        aria-label="Remove the results items from the list" title="Remove the results items from the list"
        (click)="onButtonAction('remove',selectedNode)">Remove</button>

      <button type="button" class="btn btn-light" *ngIf="showRemoveItemsMeddraNodeButton()" aria-label="Remove term"
        title="Remove selected item(s) from the Tree View Area" (click)="onButtonAction('removeAll', selectedNode)">Remove</button>

      <button type="button" class="btn btn-light" *ngIf="showLoadButton();" aria-label="Load term"
        title="Load term in the tree view area" (click)="onButtonAction('loadMeddraNode', selectedNode)">Load</button>

      <div class="btn-group" role="group">
        <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
          aria-label="Select the Version of the MedDRA to be used in this section"
          title="Select the Version of the MedDRA to be used in this section">
          Version {{ this.getMeddraCode(this.meddraService.getVersion().toString()) }}
        </button>
        <ul class="dropdown-menu scroll-container" style="max-height: 400px; overflow-y: auto;">
          <li *ngFor="let meddraVersion of supportedMeddraVersions">
            <span class="d-inline-block full-width" style="text-align: right;">
              <a class="dropdown-item"
                (click)="onButtonAction('setVersion',meddraVersion.code)">{{ meddraVersion.name }}</a>
            </span>
          </li>
        </ul>
      </div>

      <button type="button" class="btn btn-light" *ngIf="showRunButton()"
        title="Use this functionality to view the results of your query in the active area"
        (click)="onButtonAction('runQuery', selectedNode)">Run</button>

      <button type="button" class="btn btn-light" *ngIf="isMeddraLevelNode();" title="Refresh"
        (click)="onButtonAction('refreshMeddra', selectedNode)">Refresh</button>

      <button type="button" class="btn btn-light" *ngIf="isResultNode()"
        title="Use this functionality to launch the existing query again"
        (click)="onButtonAction('runQuery', selectedNode)">ReRun</button>

      <button type="button" class="btn btn-light" *ngIf="isResultNode()"
        title="Use this functionality to modify the criteria of your previous query"
        (click)="onButtonAction('moveToModifyNode', selectedNode)">Modify</button>

      <button type="button" class="btn btn-light" *ngIf="showRunToExcel()" title="To export the results of the query in an excel file"
        (click)="onButtonAction('runToExcel', selectedNode)">Run to
        Excel</button>

      <button type="button" class="btn btn-light" *ngIf="isResultNode()"
        title="Export query result as excel spreadsheet"
        (click)="onButtonAction('exportToExcel', selectedNode)">Excel</button>

      <div class="d-inline-block" title="Deselect All">
        <button type="button" class="btn btn-light" *ngIf="showDeselectAllButton()" aria-label="Deselect All"
          title="Deselect All" (click)="onButtonAction('deselectAll', selectedNode)"
          [disabled]="!isEnabledDeselectAll(selectedNode)">&#x2610;</button>
      </div>

      <div class="d-inline-block" title="Select All">
        <button type="button" class="btn btn-light" *ngIf="showSelectAllButton()" aria-label="Select All"
          title="Select All" (click)="onButtonAction('selectAll', selectedNode)"
          [disabled]="!isEnabledSelectAll(selectedNode)">&#x2611;</button>
      </div>

      <button type="button" class="btn btn-light" *ngIf="showLoadAllButton()" aria-label="Load"
        title="Load the selected item(s) in the tree view area"
        (click)="onButtonAction('loadSelected', selectedNode)">Load</button>

      <button type="button" class="btn btn-light" [title]="'Sort ' + (isConditionsNode() ? 'criteria ' : '') + 'fields alphabetically'" *ngIf="showSortButton()"
      (click)="onButtonAction('sortField', selectedNode, sortOrder)">
        <span *ngIf="sortOrder" class="bi bi-sort-alpha-down"></span>
        <span *ngIf="!sortOrder" class="bi bi-sort-alpha-up"></span>
      </button>
    </div>
    <div style="align-items:flex-end" *ngIf="isPaginationAllowed()">
      <button type="button" class="btn btn-light" aria-label="Back to top" title="Back to top"
        (click)="onButtonAction('topPage',selectedNode)"><i class="pi pi-arrow-up"></i></button>

      <button type="button" class="btn btn-light" aria-label="Get previous Page" title="Get previous Page"
        (click)="onButtonAction('previousPage',selectedNode)"><i class="pi pi-arrow-left"></i></button>

      <button type="button" class="btn btn-light" aria-label="Get next Page" title="Get next Page"
        (click)="onButtonAction('nextPage',selectedNode)"><i class="pi pi-arrow-right"></i></button>
    </div>
  </div>
</div>